import React from "react";
import { makeStyles } from "@material-ui/core";
import { CSVReader } from "react-papaparse";
import { KButton } from "@kyburz/kdesign-system";

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: 400,
    height: 400,
  },
  csvWrapper: {
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: 300,
    height: 50,
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: "center",
    marginTop: 16,
  },
  delimiterWrapper: {
    display: "flex",
    justifyContent: "center",
  },
}));

interface Props {
  handleOnDrop: (data: any) => void;
  delimiter: string;
  handleDelimiter: (delimiter: string) => void;
}

const CSVImporter: React.FC<Props> = ({
  handleOnDrop,
  delimiter,
  handleDelimiter,
}: Props) => {
  const classes = useStyles();

  const handleDrop = (data: any): void => {
    handleOnDrop(data);
  };

  const handleOnError = (err, file, inputElem, reason): void => {
    console.log(err, file, inputElem, reason);
  };
  return (
    <div className={classes.csvWrapper}>
      <CSVReader
        onDrop={handleDrop}
        onError={handleOnError}
        addRemoveButton
        removeButtonColor="#659cef"
        config={{ delimiter }}
      >
        <span style={{ height: "50px" }}>
          Drop CSV file here or click to upload.
        </span>
      </CSVReader>
      <div className={classes.subtitle}>Delimiter</div>
      <div className={classes.delimiterWrapper}>
        <KButton
          children=";"
          onClick={() => handleDelimiter(";")}
          style={{
            marginRight: 16,
            marginTop: 8,
            border:
              delimiter === ";" ? "1px solid #0066b3" : "1px solid #e2e2e2",
            color: delimiter === ";" ? "#0066b3" : "#383F51",
          }}
          theme="tertiary"
        />
        <KButton
          children=","
          onClick={() => handleDelimiter(",")}
          style={{
            marginRight: 16,
            marginTop: 8,
            border:
              delimiter === "," ? "1px solid #0066b3" : "1px solid #e2e2e2",
            color: delimiter === "," ? "#0066b3" : "#383F51",
          }}
          theme="tertiary"
        />
      </div>
    </div>
  );
};
export default CSVImporter;
